import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.MEDIUM};
  overflow-x: auto;
  overflow-y: hidden;

  table {
    border: 1px solid ${theme.light.ui.background.medium};
    border-collapse: collapse;
  }

  th,
  td {
    white-space: nowrap;
  }
`;

export const StratColCell = styled.div`
  display: flex;
  flex-direction: row;
`;
